import ColorPickerField from './ColorPickerField';

export default ColorPickerField;
